module.exports = __webpack_public_path__ + "static/blog30-2cc02a20dd5df992017a59036fa88b23.png";